function matchHeights(className) {
  const elements = document.getElementsByClassName(className);
  let maxHeight = 0;

  for (let i = 0; i < elements.length; i++) {
    const elementHeight = elements[i].offsetHeight;
    maxHeight = (elementHeight > maxHeight) ? elementHeight : maxHeight;
  }

  for (let i = 0; i < elements.length; i++) {
    elements[i].style.height = maxHeight + 'px';
  }
}

window.addEventListener('load', () => {
  matchHeights('.card__heading');
});

window.addEventListener('resize', () => {
  matchHeights('.card__heading');
});

// Monitor network requests for cart operations and add addon product when needed
document.addEventListener("DOMContentLoaded", (event) => {
  (function () {
    // Save the original fetch function
    const originalFetch = window.fetch;
    const variantId = `${window.cartStrings.cart_addon_product.variants[0].id}`; // The addon product variant ID
    const cartPagePath = "/cart"; // The cart page URL
    
    // Check cart on page load and add addon product if needed
    checkCartAndAddAddon();
    
    // Override the fetch function to intercept cart operations
    window.fetch = async function (...args) {
      const url = args[0]; // The first argument is the target URL
      
      // Log relevant cart operations
      if (url.includes('/add') || url.includes('/add.js') || 
          url.includes('/update') || url.includes('/change') ||
          url.includes('/cart/clear.js')) {
        console.log(`[Fetch] Detected request to: ${url}`);
      }
      
      // Execute the original fetch request
      const response = await originalFetch.apply(this, args);

      // Handle successful responses for relevant cart operations
      if (response.ok) {
        // After adding a product to cart
        if (url.includes('/add') || url.includes('/add.js')) {
          console.log(`[Fetch] Successful response from: ${url}`);
          let responseClone = response.clone(); // Clone the response to read the body
          let responseBody = await responseClone.json(); // Parse JSON body
          if(responseBody?.variant_id == variantId){
            if (window.cartStrings.cart_type == "drawer") {
              console.log("[Add to Cart] Refreshing cart drawer...");
              updateCartDrawer();
            } else if (window.cartStrings.cart_type == "notification") {
              console.log("[Add to Cart] Refreshing cart notification...");
              // For notification type carts, no specific action needed
              cartBubbleHtml();
            } else if (window.location.pathname === cartPagePath) {
              console.log("[Add to Cart] On cart page, reloading...");
              window.location.reload();
            }
          }else{
            await handleAddToCart();
          }
        }
        
        // After updating or changing the cart
        if (url.includes('/update') || url.includes('/change') || url.includes('/cart/clear.js')) {
          console.log(`[Fetch] Cart modification detected: ${url}`);
          let responseClone = response.clone(); // Clone the response to read the body
          let responseBody = await responseClone.json(); // Parse JSON body
          if(responseBody?.item_count == 0){
            if (window.cartStrings.cart_type == "drawer") {
              console.log("[Cart Modification] Refreshing cart drawer...");
              updateCartDrawer();
            } else if (window.cartStrings.cart_type == "notification") {
              console.log("[Cart Modification] Refreshing notification...");
              if (window.location.pathname === cartPagePath) {
                window.location.reload();
              }
            } else if (window.location.pathname === cartPagePath) {
              console.log("[Cart Modification] On cart page, reloading...");
              window.location.reload();
            }
          }else if(responseBody?.items_removed?.[0]?.variant_id == variantId || responseBody?.items_added?.[0]?.variant_id == variantId){
            if (window.cartStrings.cart_type == "drawer") {
              console.log("[Cart Modification] Refreshing cart drawer...");
              updateCartDrawer();
            } else if (window.cartStrings.cart_type == "notification") {
              console.log("[Cart Modification] Refreshing notification...");
              if (window.location.pathname === cartPagePath) {
                window.location.reload();
              }
            } else if (window.location.pathname === cartPagePath) {
              console.log("[Cart Modification] On cart page, reloading...");
              cartHtml();
            }
          }else{
            await handleCartModification();
          }
        }

      } else if ((url.includes('/add') || url.includes('/add.js') || 
                  url.includes('/update') || url.includes('/change')) && !response.ok) {
        console.error(`[Fetch] Request to ${url} failed with status: ${response.status}`);
      }
      
      // Return the original response
      return response;
    };

    function cartBubbleHtml() {
      fetch(window.Shopify.routes.root +'?section_id=cart-icon-bubble')
      .then((response) => response.text())
      .then((responseText) => {	
        let bubbleId = '.cart-count-bubble';
        let bubbleHtml = new DOMParser().parseFromString(responseText, 'text/html')  
        let bubbleDestination = document.querySelector(bubbleId);
        let bubblesource = bubbleHtml.querySelector(bubbleId);	
        if (bubblesource && bubbleDestination) bubbleDestination.innerHTML = bubblesource.innerHTML;	
        if (!bubblesource && bubbleDestination) {
          bubbleDestination.remove();
        }
      });
    }

    function cartHtml(){

      fetch(window.Shopify.routes.root +'?section_id=template--24263700906354__cart-items')
      .then((response) => response.text())
      .then((responseText) => {			  
        let cartid = 'main-cart-items';
        let html = new DOMParser().parseFromString(responseText, 'text/html')  
        let destination = document.querySelector('.cart__items');
        let source = html.getElementById(cartid);			  
        if (source && destination) destination.innerHTML = source.innerHTML;	
      });
      cartBubbleHtml();
    }
    
    // Function to check cart on page load and add addon if needed
    async function checkCartAndAddAddon() {
      console.log("[Page Load] Checking cart for addon product...");
      
      try {
        // Fetch the current cart
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        
        // Check if the addon variant is already in the cart
        const isAddonInCart = cartData.items.some(item => item.id.toString() === variantId);
        
        // Check if there are products other than the addon in the cart
        const hasOtherProducts = cartData.items.some(item => item.id.toString() !== variantId);
        
        if (!isAddonInCart && hasOtherProducts) {
          console.log(`[Page Load] Cart has products but no addon. Adding addon product ${variantId}...`);
          
          // Add the addon product to the cart
          const addResponse = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
          
          if (addResponse.ok) {
            console.log(`[Page Load] Addon product ${variantId} added successfully.`);
            
            // If on cart page, reload it
            if (window.location.pathname === cartPagePath) {
              console.log("[Page Load] On cart page, reloading...");
              window.location.reload();
            }
          } else {
            console.error(`[Page Load] Failed to add addon product ${variantId}.`, await addResponse.json());
          }
        } else if (isAddonInCart) {
          console.log(`[Page Load] Addon product ${variantId} is already in the cart.`);
        } else if (!hasOtherProducts) {
          console.log(`[Page Load] No products in cart or only addon product. No action needed.`);
        }
      } catch (error) {
        console.error("[Page Load] Error checking cart:", error);
      }
    }
    
    // Function to calculate the total quantity of all other products (excluding addon)
    function calculateTotalOtherProducts(cartData) {
      return cartData.items
        .filter(item => item.id.toString() !== variantId) // Excludes the add-on product
        .reduce((total, product) => total + product.quantity, 0); // Sums up quantities
    }

    function calculateAddonProductQty(cartData) {
      return cartData.items
        .filter(item => item.id.toString() == variantId) // Excludes the add-on product
        .reduce((total, product) => total + product.quantity, 0); // Sums up quantities
    }
    
    // Function to handle adding products to cart
    async function handleAddToCart() {
      console.log("[Add to Cart] Processing cart after product addition...");
      
      try {
        // Fetch the current cart
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        
        // Check if the addon variant is already in the cart
        const isAddonInCart = cartData.items.some(item => item.id.toString() === variantId);
        
        // Check if there are products other than the addon in the cart
        const hasOtherProducts = cartData.items.some(item => item.id.toString() !== variantId);

        let totalOtherProductsQty = calculateTotalOtherProducts(cartData);
        let totalAddonQty = calculateAddonProductQty(cartData);

        let qtyToAdd = Number(totalOtherProductsQty);

        if(isAddonInCart){
          qtyToAdd = Number(totalOtherProductsQty) - Number(totalAddonQty);
        }
        
        if (hasOtherProducts) {
          console.log(`[Add to Cart] Adding addon product ${variantId}...`);
          
          // Add the addon product to the cart
          let addResponse = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: variantId,
              quantity: Number(qtyToAdd)
            })
          });
          
          if (addResponse.ok) {
            console.log(`[Add to Cart] Addon product ${variantId} added successfully.`);
            
            // Handle different cart types
            if (window.cartStrings.cart_type == "drawer") {
              console.log("[Add to Cart] Refreshing cart drawer...");
              updateCartDrawer();
            } else if (window.cartStrings.cart_type == "notification") {
              console.log("[Add to Cart] Refreshing cart notification...");
              // For notification type carts, no specific action needed
              cartBubbleHtml();
            } else if (window.location.pathname === cartPagePath) {
              console.log("[Add to Cart] On cart page, reloading...");
              window.location.reload();
            }
          } else {
            console.error(`[Add to Cart] Failed to add addon product ${variantId}.`, await addResponse.json());
          }
        }
      } catch (error) {
        console.error("[Add to Cart] Error processing cart:", error);
      }
    }
    
    // Function to handle cart modifications (update, change, clear)
    async function handleCartModification() {
      console.log("[Cart Modification] Processing cart after modification...");
      
      try {
        // Fetch the current cart
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        
        // Check if the addon variant is already in the cart
        const isAddonInCart = cartData.items.some(item => item.id.toString() === variantId);
        
        // Check if there are products other than the addon in the cart
        const hasOtherProducts = cartData.items.some(item => item.id.toString() !== variantId);
        
        let totalOtherProductsQty = calculateTotalOtherProducts(cartData);
        
        // If only the addon product is left in the cart, remove it
        if (isAddonInCart && !hasOtherProducts && cartData.items.length === 1) {
          console.log("[Cart Modification] Only addon product left in cart. Removing it...");
          
          // Clear the cart
          const clearResponse = await fetch("/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            }
          });
          
          if (clearResponse.ok) {
            console.log("[Cart Modification] Cart cleared successfully.");
            
            // Handle different cart types after clearing
            if (window.cartStrings.cart_type == "drawer") {
              console.log("[Cart Modification] Refreshing cart drawer after clear...");
              updateCartDrawer();
            } else if (window.cartStrings.cart_type == "notification") {
              console.log("[Cart Modification] Refreshing notification after clear...");
              if (window.location.pathname === cartPagePath) {
                window.location.reload();
              }
            } else if (window.location.pathname === cartPagePath) {
              console.log("[Cart Modification] On cart page, reloading after clear...");
              window.location.reload();
            }
          } else {
            console.error("[Cart Modification] Failed to clear cart.");
          }
        }
        // If there are other products but no addon, add the addon
        else if (!isAddonInCart && hasOtherProducts) {
          console.log(`[Cart Modification] Adding addon product ${variantId} after cart modification...`);
          
          // Add the addon product to the cart
          let addResponse = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: variantId,
              quantity: Number(totalOtherProductsQty)
            })
          });
          
          if (addResponse.ok) {
            console.log(`[Cart Modification] Addon product ${variantId} added successfully.`);
            
            // Handle different cart types
            if (window.cartStrings.cart_type == "drawer") {
              console.log("[Cart Modification] Refreshing cart drawer...");
              updateCartDrawer();
            } else if (window.cartStrings.cart_type == "notification") {
              console.log("[Cart Modification] Refreshing notification...");
              if (window.location.pathname === cartPagePath) {
                window.location.reload();
              }
            } else if (window.location.pathname === cartPagePath) {
              console.log("[Cart Modification] On cart page, reloading...");
              // window.location.reload();
              cartHtml();
            }
          } else {
            console.error(`[Cart Modification] Failed to add addon product ${variantId}.`, await addResponse.json());
          }
        } else {
          // console.log(`[Cart Modification] No special action needed. Addon in cart: ${isAddonInCart}, Other products: ${hasOtherProducts}`);
          // update the addon product to the cart
          let addResponse = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: variantId,
              quantity: Number(totalOtherProductsQty)
            })
          });
          
          if (addResponse.ok) {
            console.log(`[Cart Modification] Addon product ${variantId} update successfully.`);
            
            // Handle different cart types
            if (window.cartStrings.cart_type == "drawer") {
              console.log("[Cart Modification] Refreshing cart drawer...");
              updateCartDrawer();
            } else if (window.cartStrings.cart_type == "notification") {
              console.log("[Cart Modification] Refreshing notification...");
              if (window.location.pathname === cartPagePath) {
                window.location.reload();
              }
            } else if (window.location.pathname === cartPagePath) {
              console.log("[Cart Modification] On cart page, reloading...");
              // window.location.reload();
              cartHtml();
            }
          } else {
            console.error(`[Cart Modification] Failed to update addon product ${variantId}.`, await addResponse.json());
          }
        }
      } catch (error) {
        console.error("[Cart Modification] Error processing cart:", error);
      }
    }
    
    // Function to update cart drawer UI
    function updateCartDrawer() {
      fetch(window.location.href, { cache: "no-store" }) // Fetch fresh content
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        
        const newCartDrawer = doc.querySelector("cart-drawer #CartDrawer");
        const currentCartDrawer = document.querySelector("cart-drawer #CartDrawer");
        
        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML; // Replace content
          console.log("[Cart Drawer] Updated successfully!");
          eventCartOverlayClick();
        } else {
          console.error("[Cart Drawer] Not found in the new content.");
        }
      })
      .catch(error => console.error("[Cart Drawer] Error updating:", error));

      cartBubbleHtml();
    }
    
    // Function to handle cart drawer overlay click
    function eventCartOverlayClick() {
      const overlay = document.querySelector("#CartDrawer-Overlay");
      if (overlay) {
        overlay.addEventListener("click", function (e) {
          e.currentTarget.closest("cart-drawer").querySelector(".drawer__close").click();
        });
      }
    }
  })();

  document.querySelectorAll("[REDIRECT_TO_PDP]").forEach(el => {
    el.addEventListener("click", function(e){
      location.href = e.currentTarget.dataset.href;
    })
  })
})

// ############## Updated Code Ends ###############




























